import type { ReactNode } from 'react';
import type { Filters } from '@/interfaces';
import getConfig from 'next/config';
import { filtersToHotelPageBrowserQueryParams } from '@/utils/url/hotelPageQueryParams';
import { stringify } from 'querystring';

const { publicRuntimeConfig } = getConfig();

export interface ShareBarProps {
    hotelKey: string;
    hotelName: string;
    filters: Filters;
}

const renderShareLink = (url: string, icon: string, label: string): ReactNode => (
    // biome-ignore lint/a11y/useAnchorContent: This was set before biome was added
    <a href={url} target="_blank" rel="noopener noreferrer" aria-label={label} className={`icon ${icon} u-ml16`} />
);

export const ShareBar = ({ hotelName, hotelKey, filters }: ShareBarProps) => {
    const shareUrl = `https://www.finn.no${publicRuntimeConfig.basePath}/detaljer/${hotelKey}/?${filtersToHotelPageBrowserQueryParams(
        filters,
    )}`;

    const mailParams = stringify({
        to: '',
        subject: hotelName,
        body: shareUrl,
    });
    const facebookParams = stringify({ u: shareUrl });
    const twitterParams = stringify({ text: shareUrl });
    return (
        <div>
            {renderShareLink(`mailto:?${mailParams}`, 'icon--mail', 'Del på e-post')}
            {renderShareLink(`https://www.facebook.com/sharer/sharer.php?${facebookParams}`, 'icon--facebook', 'Del på facebook')}
            {renderShareLink(`https://twitter.com/intent/tweet?${twitterParams}`, 'icon--twitter', 'Del på twitter')}
        </div>
    );
};
